export const initialState = {
    name: '',
    clusterID: '',
    capacity: '',
};

export const trsNodesPath = '/trs-nodes';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'TRS Nodes', path: trsNodesPath },
    { label: 'Add Node', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'TRS Nodes', path: trsNodesPath },
    { label: 'Edit Node', path: '' },
];

export const addHeader = 'Node Details';
export const editHeader = 'Edit Node Details';

export const ERROR_MESSAGES = {
    NAME_REQUIRED: 'Node name is required',
    CLUSTER_REQUIRED: 'Cluster is required',
    CAPACITY_REQUIRED: 'Capacity is required',
    NODE_NAME_REQUIRED:
        'Node name is required and must be at least 2 characters',
    CAPACITY_INVALID: 'Capacity must be a positive number',
};
